<template>
    <div class="main">
        <b-navbar fixed="top" type="light" variant="faded">
            <div class="navbar-left">
                <slot name="navbar-left"/>
            </div>

            <div class="navbar-center">
                <b-navbar-brand class="navbar-brand mx-auto" v-bind="navbarBrandProps">
                    <b-img alt="CSP Logo" height="160" :src="logoImage" width="43"/>
                </b-navbar-brand>
            </div>

            <div class="navbar-right">
                <ul class="navbar-nav navbar-expand justify-content-end">
                    <li class="nav-item d-flex align-items-center mr-1">
                        <csp-global-loading-indicator/>
                    </li>
                    <slot name="navbarRightItems"/>
                </ul>
            </div>
        </b-navbar>

        <csp-new-version-warning/>

        <b-container class="container-main" fluid="xl">
            <slot/>
        </b-container>

        <div v-if="shouldShowImprintLinks" class="imprint-wrapper">
            <a href="https://autoclaim.de/impressum/" rel="noopener noreferrer" target="_blank">Impressum</a>
            <span>&bull;</span>
            <a href="https://autoclaim.de/datenschutz/" rel="noopener noreferrer" target="_blank">Datenschutz</a>
            <span>&bull;</span>
            <a href="/de/Schaden-Manager/" rel="noopener noreferrer">Desktop</a>
        </div>
    </div>
</template>

<script>
    import logoAutoclaim from '@csp-app/images/logo-autoclaim.svg';
    import Container from '@services/Container';

    export default {
        props: {
            homeRouteName: {
                type: String,
                default: '',
            },
            shouldShowImprintLinks: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                logoImage: logoAutoclaim,
            }
        },
        computed: {
            navbarBrandProps() {
                const props = {};
                if (this.homeRouteName) {
                    props.to = {name: this.homeRouteName};
                }
                return props;
            },
        },
        mounted() {
            const container = Container.getInstance();
            const flashMessenger = container.getFlashMessenger();
            flashMessenger.setToaster(this.$bvToast);
        },
    }
</script>
